import { render, staticRenderFns } from "./ClientAddressEditCard.vue?vue&type=template&id=0d7a8e7b&"
import script from "./ClientAddressEditCard.vue?vue&type=script&lang=js&"
export * from "./ClientAddressEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports